<template>
  <div class="bg-gray rounded p-2">
    <div class="bg-white rounded p-3">
      <div class="row">
        <div class="col-12">
          <span class="title d-flex align-items-center">
            <div class="circle-icon d-flex mr-2">
              <span class="fa-stack fa-1x">
                <i class="fas fa-circle fa-stack-2x text-white" />
                <i class="fas fa-flag fa-stack-1x text-orange" />
              </span>
            </div>
            <span>Información de Notificado</span>
          </span>
        </div>

        <div class="col-12">
          <div class="pt-3 px-3">
            <ValidationObserver ref="form" tag="div" class="row">
              <div class="col-12 col-lg-4 pt-2 pt-0-lg">
                <ValidationProvider
                  v-slot="{ errors }"
                  mode="lazy"
                  rules="required"
                  :custom-messages="{
                    required: 'Favor escriba el nombre del director.',
                  }"
                >
                  <CustomInput
                    v-model="model.director"
                    label="Nombre del Director:"
                    regular-label
                    :error="errors[0]"
                    :custom-error-msg="errors[0]"
                  />
                </ValidationProvider>
              </div>

              <div class="col-12 col-lg-4 pt-2 pt-0-lg">
                <CustomInput
                  label="Nombre del Secretario:"
                  regular-label
                  disabled
                  :value="catalog.minister"
                />
              </div>

              <div class="col-12 col-lg-4 pt-2">
                <label />
                <div
                  class="mt-2 d-flex flex-column flex-lg-row justify-content-lg-end"
                >
                  <ActionButton
                    text="Cancelar"
                    variant="outline-danger"
                    i="fas fa-times-circle"
                    class="w-100 w-lg-0"
                    @click="cancel"
                  />
                  <div class="my-1 mx-1 my-lg-0 mx-lg-2" />
                  <ActionButton
                    text="Guardar"
                    variant="success"
                    i="fas fa-save"
                    class="w-100 w-lg-0"
                    @click="submit"
                  />
                </div>
              </div>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import { getSysParamById } from '@/modules/system-parameter-managment/api';
import alert from '@/mixin/alert.mixin';

const initialModel = () => ({ director: null });

export default {
  name: 'ChangeOfStatusNotify',
  mixins: [alert],
  components: { ActionButton, CustomInput },
  props: {
    tapRequestId: { type: [Number, String], required: true, default: null },
  },
  data: () => ({
    model: initialModel(),
    catalog: { minister: null },
  }),
  methods: {
    async initCatalog() {
      try {
        const {
          data: { staticValue = null },
        } = await getSysParamById(3668);
        this.catalog.minister = staticValue;
      } catch {
        //
      }
    },
    async submit() {
      const valid = await this.$refs['form'].validate();
      if (valid) {
        try {
          const payload = {
            requestId: this.tapRequestId,
            directorName: this.model.director,
          };
          await this.$ApiPost('/api/tapRequests/notification', payload);
          this.cancel(false);
          this.$emit('success');
        } catch (error) {
          this.ShowToast('Error', error.response.data.message, 'error');
          this.cancel();
        }
      }
    },
    cancel(emit = true) {
      this.model = initialModel();
      this.$refs['form']?.reset();
      if (emit) {
        this.$emit('cancel');
      }
    },
  },
  async created() {
    await this.initCatalog();
  },
};
</script>

<style lang="scss" scoped>
.w-lg-0 {
  @media (min-width: 992px) {
    width: inherit !important;
  }
}
.reason-container {
  .circle-icon {
    box-shadow: 0px 3px 6px #00000029;
    width: 35px;
    border-radius: 35px;
  }
  .title {
    font: normal normal bold 16px/19px Lato;
    color: #3f5b60;
  }
}
textarea {
  min-height: 50px !important;
}
</style>
